/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifactpackctaprimary3Inputs */

const en_artifactpackctaprimary3 = /** @type {(inputs: Artifactpackctaprimary3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate my pack — €149`)
};

const pt_artifactpackctaprimary3 = /** @type {(inputs: Artifactpackctaprimary3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerar o meu pack — €149`)
};

/**
* | output |
* | --- |
* | "Generate my pack — €149" |
*
* @param {Artifactpackctaprimary3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const artifactpackctaprimary3 = /** @type {((inputs?: Artifactpackctaprimary3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifactpackctaprimary3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_artifactpackctaprimary3(inputs)
	return pt_artifactpackctaprimary3(inputs)
});
export { artifactpackctaprimary3 as "artifactPackCtaPrimary" }